import axios from 'axios'
import {
  MACHINE_CREATE_REQUEST,
  MACHINE_CREATE_SUCCESS,
  MACHINE_CREATE_FAIL,
  MACHINE_LIST_REQUEST,
  MACHINE_LIST_SUCCESS,
  MACHINE_LIST_FAIL,
  MACHINE_UPDATE_REQUEST,
  MACHINE_UPDATE_SUCCESS,
  MACHINE_UPDATE_FAIL,
  MACHINE_DELETE_REQUEST,
  MACHINE_DELETE_SUCCESS,
  MACHINE_DELETE_FAIL,
} from '../constants/machineConstants'

export const createMachine = (machine) => async (dispatch, getState) => {
  try {
    dispatch({
      type: MACHINE_CREATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(`/api/machines`, machine, config)

    dispatch({
      type: MACHINE_CREATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: MACHINE_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getMachinesByUserId = (user) => async (dispatch, getState) => {
  try {
    dispatch({ type: MACHINE_LIST_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
      params: {
        user,
      },
    }

    const { data } = await axios.get(`/api/machines/list`, config)

    dispatch({
      type: MACHINE_LIST_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: MACHINE_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateMachine = (machine) => async (dispatch, getState) => {
  try {
    dispatch({
      type: MACHINE_UPDATE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `/api/machines/${machine._id}`,
      machine,
      config
    )

    dispatch({
      type: MACHINE_UPDATE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: MACHINE_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const deleteMachine = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: MACHINE_DELETE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    await axios.delete(`/api/machines/${id}`, config)

    dispatch({ type: MACHINE_DELETE_SUCCESS })
  } catch (error) {
    dispatch({
      type: MACHINE_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
